module.exports = __webpack_public_path__ + "media/img/why-vendor/02-1e3ddbbdf6e8290efd1384f6ccf82211.png";